module.exports = __webpack_public_path__ + "static/media/led-lasalle-lightbulbs.19d1731e.jpg";